// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file plataforma_marketing.proto (package sextante.plataforma.marketing.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file plataforma_marketing.proto.
 */
export const file_plataforma_marketing: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * Sin parametros.
 *
 * @generated from message sextante.plataforma.marketing.v1.ListCampanasRequest
 */
export type ListCampanasRequest = Message<"sextante.plataforma.marketing.v1.ListCampanasRequest"> & {
};

/**
 * Describes the message sextante.plataforma.marketing.v1.ListCampanasRequest.
 * Use `create(ListCampanasRequestSchema)` to create a new message.
 */
export const ListCampanasRequestSchema: GenMessage<ListCampanasRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_marketing, 0);

/**
 * Campanas no eliminadas, de la mas reciente a la mas antigua.
 *
 * @generated from message sextante.plataforma.marketing.v1.ListCampanasResponse
 */
export type ListCampanasResponse = Message<"sextante.plataforma.marketing.v1.ListCampanasResponse"> & {
  /**
   * @generated from field: repeated sextante.plataforma.marketing.v1.CampanaItem items = 1;
   */
  items: CampanaItem[];
};

/**
 * Describes the message sextante.plataforma.marketing.v1.ListCampanasResponse.
 * Use `create(ListCampanasResponseSchema)` to create a new message.
 */
export const ListCampanasResponseSchema: GenMessage<ListCampanasResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_marketing, 1);

/**
 * Campana de marketing.
 *
 * @generated from message sextante.plataforma.marketing.v1.CampanaItem
 */
export type CampanaItem = Message<"sextante.plataforma.marketing.v1.CampanaItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string nombre = 2;
   */
  nombre: string;

  /**
   * landing | whatsapp | email
   *
   * @generated from field: string tipo = 3;
   */
  tipo: string;

  /**
   * @generated from field: string objetivo = 4;
   */
  objetivo: string;

  /**
   * Codigo de la campana. Unico entre campanas no eliminadas.
   *
   * @generated from field: optional string codigo = 5;
   */
  codigo?: string | undefined;

  /**
   * 0 = sin limite.
   *
   * @generated from field: int32 cupos_maximos = 6;
   */
  cuposMaximos: number;

  /**
   * Registros que ya entraron por la campana.
   *
   * @generated from field: int32 cupos_usados = 7;
   */
  cuposUsados: number;

  /**
   * Unix ms
   *
   * @generated from field: optional int64 fecha_limite = 8;
   */
  fechaLimite?: bigint | undefined;

  /**
   * @generated from field: optional string url_landing = 9;
   */
  urlLanding?: string | undefined;

  /**
   * true si quien se registra por la campana recibe una demo.
   *
   * @generated from field: bool activa_demo = 10;
   */
  activaDemo: boolean;

  /**
   * borrador | activa | finalizada
   *
   * @generated from field: string estado = 11;
   */
  estado: string;

  /**
   * Plantilla del mensaje de la campana.
   *
   * @generated from field: optional string mensaje_template = 12;
   */
  mensajeTemplate?: string | undefined;
};

/**
 * Describes the message sextante.plataforma.marketing.v1.CampanaItem.
 * Use `create(CampanaItemSchema)` to create a new message.
 */
export const CampanaItemSchema: GenMessage<CampanaItem> = /*@__PURE__*/
  messageDesc(file_plataforma_marketing, 2);

/**
 * Campana sobre la que se actua.
 *
 * @generated from message sextante.plataforma.marketing.v1.CampanaIdRequest
 */
export type CampanaIdRequest = Message<"sextante.plataforma.marketing.v1.CampanaIdRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message sextante.plataforma.marketing.v1.CampanaIdRequest.
 * Use `create(CampanaIdRequestSchema)` to create a new message.
 */
export const CampanaIdRequestSchema: GenMessage<CampanaIdRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_marketing, 3);

/**
 * Campana con sus contactos.
 *
 * @generated from message sextante.plataforma.marketing.v1.CampanaDetalleResponse
 */
export type CampanaDetalleResponse = Message<"sextante.plataforma.marketing.v1.CampanaDetalleResponse"> & {
  /**
   * @generated from field: sextante.plataforma.marketing.v1.CampanaItem campana = 1;
   */
  campana?: CampanaItem | undefined;

  /**
   * @generated from field: repeated sextante.plataforma.marketing.v1.CampanaContactoItem contactos = 2;
   */
  contactos: CampanaContactoItem[];
};

/**
 * Describes the message sextante.plataforma.marketing.v1.CampanaDetalleResponse.
 * Use `create(CampanaDetalleResponseSchema)` to create a new message.
 */
export const CampanaDetalleResponseSchema: GenMessage<CampanaDetalleResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_marketing, 4);

/**
 * Contacto que se registro por la landing de la campana, con su oportunidad del pipeline.
 *
 * @generated from message sextante.plataforma.marketing.v1.CampanaContactoItem
 */
export type CampanaContactoItem = Message<"sextante.plataforma.marketing.v1.CampanaContactoItem"> & {
  /**
   * @generated from field: string oportunidad_id = 1;
   */
  oportunidadId: string;

  /**
   * @generated from field: string cliente_id = 2;
   */
  clienteId: string;

  /**
   * @generated from field: string cliente_nombre = 3;
   */
  clienteNombre: string;

  /**
   * Etapa actual de la oportunidad en el pipeline.
   *
   * @generated from field: string stage = 4;
   */
  stage: string;

  /**
   * Unix ms
   *
   * @generated from field: int64 fecha_registro = 5;
   */
  fechaRegistro: bigint;
};

/**
 * Describes the message sextante.plataforma.marketing.v1.CampanaContactoItem.
 * Use `create(CampanaContactoItemSchema)` to create a new message.
 */
export const CampanaContactoItemSchema: GenMessage<CampanaContactoItem> = /*@__PURE__*/
  messageDesc(file_plataforma_marketing, 5);

/**
 * Sin parametros.
 *
 * @generated from message sextante.plataforma.marketing.v1.CampanaStatsRequest
 */
export type CampanaStatsRequest = Message<"sextante.plataforma.marketing.v1.CampanaStatsRequest"> & {
};

/**
 * Describes the message sextante.plataforma.marketing.v1.CampanaStatsRequest.
 * Use `create(CampanaStatsRequestSchema)` to create a new message.
 */
export const CampanaStatsRequestSchema: GenMessage<CampanaStatsRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_marketing, 6);

/**
 * Totales de campanas para los KPI.
 *
 * @generated from message sextante.plataforma.marketing.v1.CampanaStatsResponse
 */
export type CampanaStatsResponse = Message<"sextante.plataforma.marketing.v1.CampanaStatsResponse"> & {
  /**
   * @generated from field: int32 total_campanas = 1;
   */
  totalCampanas: number;

  /**
   * @generated from field: int32 activas = 2;
   */
  activas: number;

  /**
   * @generated from field: int32 total_registros = 3;
   */
  totalRegistros: number;

  /**
   * @generated from field: int32 demos_activadas = 4;
   */
  demosActivadas: number;
};

/**
 * Describes the message sextante.plataforma.marketing.v1.CampanaStatsResponse.
 * Use `create(CampanaStatsResponseSchema)` to create a new message.
 */
export const CampanaStatsResponseSchema: GenMessage<CampanaStatsResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_marketing, 7);

/**
 * Campana a crear o editar.
 *
 * @generated from message sextante.plataforma.marketing.v1.GuardarCampanaRequest
 */
export type GuardarCampanaRequest = Message<"sextante.plataforma.marketing.v1.GuardarCampanaRequest"> & {
  /**
   * @generated from field: optional string id = 1;
   */
  id?: string | undefined;

  /**
   * @generated from field: string nombre = 2;
   */
  nombre: string;

  /**
   * @generated from field: string tipo = 3;
   */
  tipo: string;

  /**
   * @generated from field: string objetivo = 4;
   */
  objetivo: string;

  /**
   * @generated from field: optional string codigo = 5;
   */
  codigo?: string | undefined;

  /**
   * @generated from field: int32 cupos_maximos = 6;
   */
  cuposMaximos: number;

  /**
   * Unix ms
   *
   * @generated from field: optional int64 fecha_limite = 7;
   */
  fechaLimite?: bigint | undefined;

  /**
   * @generated from field: optional string url_landing = 8;
   */
  urlLanding?: string | undefined;

  /**
   * @generated from field: bool activa_demo = 9;
   */
  activaDemo: boolean;

  /**
   * @generated from field: optional string mensaje_template = 10;
   */
  mensajeTemplate?: string | undefined;
};

/**
 * Describes the message sextante.plataforma.marketing.v1.GuardarCampanaRequest.
 * Use `create(GuardarCampanaRequestSchema)` to create a new message.
 */
export const GuardarCampanaRequestSchema: GenMessage<GuardarCampanaRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_marketing, 8);

/**
 * Estado nuevo de una campana: borrador, activa o finalizada.
 *
 * @generated from message sextante.plataforma.marketing.v1.CambiarEstadoCampanaRequest
 */
export type CambiarEstadoCampanaRequest = Message<"sextante.plataforma.marketing.v1.CambiarEstadoCampanaRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string estado = 2;
   */
  estado: string;
};

/**
 * Describes the message sextante.plataforma.marketing.v1.CambiarEstadoCampanaRequest.
 * Use `create(CambiarEstadoCampanaRequestSchema)` to create a new message.
 */
export const CambiarEstadoCampanaRequestSchema: GenMessage<CambiarEstadoCampanaRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_marketing, 9);

/**
 * Sin datos: que el rpc no falle ya indica que se hizo.
 *
 * @generated from message sextante.plataforma.marketing.v1.CampanaAccionResponse
 */
export type CampanaAccionResponse = Message<"sextante.plataforma.marketing.v1.CampanaAccionResponse"> & {
};

/**
 * Describes the message sextante.plataforma.marketing.v1.CampanaAccionResponse.
 * Use `create(CampanaAccionResponseSchema)` to create a new message.
 */
export const CampanaAccionResponseSchema: GenMessage<CampanaAccionResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_marketing, 10);

/**
 * Campanas de marketing de la app Plataforma (menu Marketing). Migracion a gRPC-Web con logica propia
 * (ver CLAUDE.md). El registro publico de la landing sigue en REST (lo usa otra app). Solo los campos que
 * usa la web. Requiere sesion de Plataforma.
 *
 * @generated from service sextante.plataforma.marketing.v1.MarketingPlataformaService
 */
export const MarketingPlataformaService: GenService<{
  /**
   * Campanas no eliminadas, de la mas reciente a la mas antigua.
   *
   * @generated from rpc sextante.plataforma.marketing.v1.MarketingPlataformaService.ListCampanas
   */
  listCampanas: {
    methodKind: "unary";
    input: typeof ListCampanasRequestSchema;
    output: typeof ListCampanasResponseSchema;
  },
  /**
   * Campana + contactos (registros de la landing con su oportunidad), del mas reciente al mas antiguo.
   *
   * @generated from rpc sextante.plataforma.marketing.v1.MarketingPlataformaService.GetDetalle
   */
  getDetalle: {
    methodKind: "unary";
    input: typeof CampanaIdRequestSchema;
    output: typeof CampanaDetalleResponseSchema;
  },
  /**
   * Totales para los KPIs del listado.
   *
   * @generated from rpc sextante.plataforma.marketing.v1.MarketingPlataformaService.GetStats
   */
  getStats: {
    methodKind: "unary";
    input: typeof CampanaStatsRequestSchema;
    output: typeof CampanaStatsResponseSchema;
  },
  /**
   * Alta (nace en borrador) o edicion. Codigo unico entre campanas no eliminadas.
   *
   * @generated from rpc sextante.plataforma.marketing.v1.MarketingPlataformaService.Guardar
   */
  guardar: {
    methodKind: "unary";
    input: typeof GuardarCampanaRequestSchema;
    output: typeof CampanaItemSchema;
  },
  /**
   * borrador | activa | finalizada.
   *
   * @generated from rpc sextante.plataforma.marketing.v1.MarketingPlataformaService.CambiarEstado
   */
  cambiarEstado: {
    methodKind: "unary";
    input: typeof CambiarEstadoCampanaRequestSchema;
    output: typeof CampanaItemSchema;
  },
  /**
   * Baja logica. Idempotente.
   *
   * @generated from rpc sextante.plataforma.marketing.v1.MarketingPlataformaService.Eliminar
   */
  eliminar: {
    methodKind: "unary";
    input: typeof CampanaIdRequestSchema;
    output: typeof CampanaAccionResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_plataforma_marketing, 0);

